module.exports = __webpack_public_path__ + "img/logo.a923a65a.svg";